import msIcon from 'assets/images/social_media_ms.svg';
import { GenericConnection } from './generic-connection';
import { Integration } from 'services/integration-service';

/**
 * OneDrive Connection Component
 * 
 * Provides interface for connecting Microsoft OneDrive to the application.
 * Uses the generic connection component with OneDrive specific configuration.
 * 
 * @param onBack - Callback function to go back to connectors list
 * @param existingIntegration - Existing integration if any
 * @returns A OneDrive connection interface
 */

interface OneDriveConnectionProps {
    onBack: () => void;
    existingIntegration?: Integration;
}

const oneDriveConfig = {
    id: 'onedrive',
    name: 'Microsoft OneDrive',
    description: 'ONE_DRIVE_DESCRIPTION',
    longDescription: 'LONG_DRIVE_LONG_DESCRIPTION',
    icon: msIcon,
    iconAlt: 'Microsoft OneDrive',
    category: 'Productivity',
    developer: 'Microsoft',
    website: 'https://onedrive.live.com',
    privacyPolicy: 'https://privacy.microsoft.com'
};

export const OneDriveConnection = ({ onBack, existingIntegration }: OneDriveConnectionProps) => {
    return (
        <GenericConnection
            onBack={onBack}
            integrationConfig={oneDriveConfig}
            existingIntegration={existingIntegration}
        />
    );
};
